import React from 'react';
import Logo from '../Logo/Logo';

import * as styles from './Brand.module.css';
import { navigate } from 'gatsby';

const Brand = (props) => {
  
  return (
    <div className={`${styles.root} header-logo`} role={'presentation'} onClick={() => navigate('/')}>
      <Logo />
    </div>
  );
};

export default Brand;
